/*
 * @providesModule NotificationToastStyle
 *
 */
import {default as SkillzStyle, darkenColor, lightenColor} from 'SkillzStyle';
import Sizes from 'Sizes';

import {StyleSheet} from 'react-native';

const {
  fontBold,
  fontPrimaryItalic,
  fontRegular,
  fontSecondary,
  fontSizeH3,
  fontSizeH4,
  fontSizeH5,
  textColorPrimary,
  textColorSecondary,
  viewCornerRadiusPrimary,
  viewPrimaryColor,
  viewSecondaryColor,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  animatedView: {
    left: 0,
    right: 0,
    position: 'absolute',
  },

  mainContainer: {
    marginTop: 0,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    ...viewSecondaryColor,
    paddingVertical: 10,
  },

  textContainer: {
    alignItems: 'flex-start',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'stretch',
    marginRight: 10,
  },

  icon: {
    height: 50,
    width: 50,
    marginLeft: 10,
    marginRight: 10,
  },

  primaryText: {
    textAlign: 'left',
    ...fontSecondary,
    ...textColorSecondary,
    ...fontSizeH3,
  },

  secondaryText: {
    textAlign: 'left',
    ...fontPrimaryItalic,
    ...textColorSecondary,
    ...fontSizeH5,
  },

  message: {
    alignSelf: 'stretch',
    textAlign: 'left',
    ...fontRegular,
    ...textColorSecondary,
    ...fontSizeH3,
  },

  // Chat styles

  chatContainer: {
    flexDirection: 'column',
    ...viewSecondaryColor,
  },

  newMessagesBar: {
    alignSelf: 'flex-start',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    width: Sizes.screenWidth,
    ...viewPrimaryColor,
  },

  chatIconContainer: {
    height: 30,
    width: 30,
    margin: 5,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 0.3,
    borderColor: darkenColor(viewPrimaryColor.backgroundColor),
    backgroundColor: lightenColor(viewPrimaryColor.backgroundColor),
    ...viewCornerRadiusPrimary,
  },

  chatIcon: {
    width: 18,
    height: 18,
  },

  newMessagesLabel: {
    ...fontBold,
    ...fontSizeH4,
    ...textColorPrimary,
  },

  chatTextContainer: {
    margin: 5,
    padding: 5,
  },

  contactNameLabel: {
    ...fontBold,
    ...fontSizeH4,
    ...textColorSecondary,
  },

  messageLabel: {
    ...fontRegular,
    ...fontSizeH4,
    ...textColorSecondary,
  },
  // Merge Account styles

  mergeAccountMainContainer: {
    borderRadius: 10,
    marginTop: 2,
    marginHorizontal: 10,
    paddingRight: 10,
  },

  mergeAccountIcon: {
    height: 24,
    width: 24,
    marginLeft: 16,
    marginRight: 16,
  },

  // Rounded Toast styles
  roundedToastContainer: {
    borderRadius: 10,
    marginTop: 10,
    marginHorizontal: 10,
    paddingRight: 16, // Use the same offset on the right as the left margin below
  },

  roundedToastIcon: {
    height: 60,
    width: 60,
    marginHorizontal: 16,
  },

  roundedPrimaryText: {
    ...fontBold,
    ...fontSizeH3,
    ...textColorSecondary,
  },

  roundedSecondaryText: {
    ...fontRegular,
    ...fontSizeH4,
    ...textColorSecondary,
  },
});
